import { setFontDetailsToContext } from './set-font-details-to-context.js';

export const renderTextToCanvas = (
  ctx: CanvasRenderingContext2D,
  text: string,
  type: 'value' | 'label',
  x: number,
  y: number,
  fontSize?: number,
) => {
  setFontDetailsToContext(ctx, type, fontSize);
  ctx.fillText(text, x, y);
};
